<template>
  <l-control position="bottomright">
    <div class="info legend leaflet-control">
      <span class="mb-5">Cakupan Kumulatif</span>
      <div class="color-code">
        <i style="background: #de7062" />
        Cakupan > 75%
      </div>
      <div class="color-code">
        <i style="background: #e5936b" />
        Cakupan 50 - 75%
      </div>
      <div class="color-code">
        <i style="background: #e9ae7b" />
        Cakupan 25 - 50%
      </div>
      <div class="color-code">
        <i style="background: #e7d090" />
        Cakupan 0 - 25%
      </div>
    </div>
  </l-control>
</template>
<script>
import { LControl } from 'vue2-leaflet'

export default {
  components: {
    LControl,
  },
}
</script>
<style scoped>
.info.legend span {
  display: block;
}

.info {
  padding: 6px 8px;
  font: 14px/16px Arial, Helvetica, sans-serif;
  background: white;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.info h4 {
  margin: 0 0 5px;
  color: #777;
}

.info h3 {
  margin: 0 0 5px;
}

.info h5 {
  margin: 0 auto;
}

.info .margin-bottom-10 {
  margin-bottom: 10px;
}

.info .indicator {
  margin-top: 10px;
  font-size: 14px;
}

.info .label-primary {
  background-color: #ded817 !important;
  color: #5a5a5a !important;
}

.info .color-code {
  margin-bottom: 1px;
}

.legend {
  line-height: 18px;
  color: #555;
  padding-bottom: 10px;
}

.legend i {
  width: 18px;
  height: 18px;
  float: left;
  margin-right: 8px;
  opacity: 0.7;
}

.legend .stripe {
  background-image: linear-gradient(
    45deg,
    #ffffff 25%,
    #2b2a2a 25%,
    #2b2a2a 50%,
    #ffffff 50%,
    #ffffff 75%,
    #2b2a2a 75%,
    #2b2a2a 100%
  );
  background-size: 5px 5px;
}

.gradient {
  height: 13px;
  width: 200px;
  background-color: #bffffc; /* For browsers that do not support gradients */
  background-image: linear-gradient(to right, #bffffc, #1bc5bd);
}
.min {
  position: absolute;
  left: 8px;
  font-size: 11px;
}
.max {
  position: absolute;
  right: 8px;
  font-size: 11px;
}
</style>
